/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Cleanup_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to clean up expired keys." |
*
* @param {Profile_Security_User_Api_Key_Cleanup_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_cleanup_error = /** @type {((inputs?: Profile_Security_User_Api_Key_Cleanup_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Cleanup_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abgelaufene Schlüssel konnten nicht bereinigt werden.")
	return /** @type {LocalizedString} */ ("Failed to clean up expired keys.")
});